/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const IconDislike = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconDislike"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.16 15.175a2 2 0 0 0-1.02 1.037l-1.633 3.81A3.26 3.26 0 0 1 10.508 22 2.51 2.51 0 0 1 8 19.492V16H4a2 2 0 0 1-2-2v-3c0-4.558 3.518-8 8-8h6.085A1.5 1.5 0 0 1 17.5 2H22v14h-4.5a1.5 1.5 0 0 1-1.34-.825m-4.491 4.06a1.26 1.26 0 0 1-1.16.765.51.51 0 0 1-.509-.508V14H4v-3c0-3.442 2.61-6 6-6h6v8.121a4 4 0 0 0-2.698 2.303zM20 4v10h-2V4z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconDislike;
